export let ContextLocationName = /*#__PURE__*/function (ContextLocationName) {
  ContextLocationName["DASHBOARD"] = "dashboard";
  ContextLocationName["ACCOUNT"] = "account";
  ContextLocationName["STUDIO"] = "studio";
  return ContextLocationName;
}({});

// this class created to provide context information from location.href
// part of this code is reverse engineered from https://bo.wix.com/quix/#/notebook/7cf0a5a9-efd7-4c12-a949-a24a13244384?note=68adf45b-b734-4d78-a1a2-7b4660a71259
export class ContextURL {
  // remove / in the beginning and end of pathname
  // replace // with /
  static trimSlash(pathname) {
    const endSlice = pathname.endsWith('/') ? -1 : undefined;
    return pathname.slice(1, endSlice).replaceAll('//', '/');
  }

  // replace basic identifiers with "ID"
  static replaceBasicIds(URLPart) {
    return URLPart.replace(/\w*[0-9]\w*(-\w*){2,}/, 'ID').replace(/\/(\w*-){1,}ID/, '/ID')
    // -- Blog post ID, video ID, bookings session details
    .replace(/\w+\d+\w*/, 'ID');
  }

  // replace wix form, guest-list, shipping rule, calendar app ids
  // using specific urls
  static replaceOtherIds(URLPart) {
    return URLPart.replace(/comp-\w+/, 'ID') // Wix Form ID
    .replace(/\/guest-list\/[A-Z]+.*/, '/guest-list/ID') // Wix events, guest-list ID
    .replace(/\/guest-list\/check-ins\/[A-Z]+.*/, '/guest-list/check-ins/ID') // guest-list ID
    .replace(/\/store\/shipping-and-tax\/list\/rule\/\w+.*/, '/store/shipping-and-tax/list/rule/ID') // shipping rule ids
    .replace(/\/owner\/calendar\/\w*[0-9]\w*(-\w*){2,}/, '/owner/calendar/ID'); // calender app ID
  }

  // replace specific internal names with "NAME"/"DETAILS"
  static replaceNames(URLPart) {
    return URLPart.replace(/\/database\/data\/\w+.*/, '/database/data/NAME') // Wix Data - DB name
    .replace(/\/bookings\/scheduler\/owner\/offerings\/DELETED\/\w+.*/, '/bookings/scheduler/owner/offerings/DELETED/NAME') // Bookings delete service
    .replace(/\/admin-pages\/\w+.*/, '/admin-pages/NAME') // admin page name
    .replace(/\/brief-details\/\w+.*/, '/brief-details/DETAILS'); // lead details
  }

  // clean shoutout duplicates
  static cleanShoutout(URLPart) {
    if (new RegExp(/^\/shoutout\/.*/).test(URLPart)) {
      const uniqURLParts = Array.from(new Set(URLPart.split('/')));
      return uniqURLParts.join('/');
    }
    return URLPart;
  }

  // replace specific date from URL with "Date" string
  static replaceDate(urlPart) {
    return urlPart.replace(/\d{4}-\d{2}-\d{2}/, 'DATE');
  }
  constructor(inputURL) {
    this._URL = void 0;
    this._cleanPathname = void 0;
    this._contextLocationName = void 0;
    this._URL = new URL(inputURL);
    this._contextLocationName = this.getContextLocationName();
    this._cleanPathname = this.generateCleanPathname();
  }
  getProduct() {
    if (!this._cleanPathname) {
      return undefined;
    }
    return this._cleanPathname.split('/')[1];
  }
  getCleanPathname() {
    return this._cleanPathname;
  }

  // get name of current context location
  getContextLocationName() {
    for (const location of ContextURL.contextLocations) {
      if (this._URL.toString().includes(location.URLPart)) {
        return location.name;
      }
    }
    return undefined;
  }
  isValidContextLocation() {
    return !!this._contextLocationName;
  }
  isApp() {
    return this._URL.pathname.includes('/app/');
  }
  ensureLocationName(locationName) {
    return this._contextLocationName === locationName;
  }

  // returning main part of pathname excluding /dashboard/guid or /account
  getMainPathnamePart() {
    let skipPathnamePartsNumber = 0;

    // if dashboard - skip dashboard/{guid}
    if (this.ensureLocationName(ContextLocationName.DASHBOARD)) {
      skipPathnamePartsNumber = 2;
    }

    // if account - skip account, or if studio - skip /studio
    if (this.ensureLocationName(ContextLocationName.ACCOUNT) || this.ensureLocationName(ContextLocationName.STUDIO)) {
      skipPathnamePartsNumber = 1;
    }
    const mainPathnamePart = ContextURL.trimSlash(this._URL.pathname).split('/').slice(skipPathnamePartsNumber).join('/');
    return `/${mainPathnamePart}`;
  }
  generateCleanPathname() {
    if (!this.isValidContextLocation()) {
      return undefined;
    }
    let cleanPathname = this.getMainPathnamePart();
    if (!this.isApp()) {
      cleanPathname = ContextURL.replaceDate(cleanPathname);
      cleanPathname = ContextURL.replaceBasicIds(cleanPathname);
    }
    cleanPathname = ContextURL.replaceOtherIds(cleanPathname);
    cleanPathname = ContextURL.replaceNames(cleanPathname);
    cleanPathname = ContextURL.cleanShoutout(cleanPathname);
    return cleanPathname;
  }
}
ContextURL.contextLocations = [{
  name: ContextLocationName.DASHBOARD,
  URLPart: 'manage.wix.com/dashboard/'
}, {
  name: ContextLocationName.DASHBOARD,
  URLPart: 'manage.editorx.com/dashboard/'
}, {
  name: ContextLocationName.ACCOUNT,
  URLPart: 'manage.wix.com/account/'
}, {
  name: ContextLocationName.STUDIO,
  URLPart: 'manage.wix.com/studio/'
}];
//# sourceMappingURL=ContextURL.js.map